import styled from 'styled-components';
import { fontSizes, spacing, colors, fontWeights } from 'ui/theme';
import { GroupButton as GrpBtn } from 'ui/buttonGroup';

const BUTTON_CONSTANTS = `
  align-items: center;
  cursor: pointer;
  display: flex;
  font-weight: ${fontWeights.bold};
  font-family: "proxima-nova", "Helvetica Neue", "Helvetica", sans-serif;
  font-size: ${fontSizes.s11};
  justify-content: space-around;
  text-transform: uppercase;
  height: ${spacing.double};
  > * + * {
    margin-left: ${spacing.quarter};
  }
}
`;

const SELECTED_STYLE = `
  background: #717171;
  border-color: #333333;
  color: ${colors.white};
  :hover {
    border-color: #333333;
  }
`;

export const GroupButton = styled(GrpBtn)`
  ${BUTTON_CONSTANTS}
  && {
    ${(props) => (props.isSelected ? SELECTED_STYLE : '')};

    :focus {
      border-color: #333333;
    }
  }
  align-items: center;
  background-image: linear-gradient(#fbfcfc, #ecf0f1);
  border-color: #cfd9db;
  gap: ${spacing.half};
  border-bottom: ${spacing.eighth} solid #cfd9db;
  :hover {
    border-color: #adadad;
  }
`;
